module.exports = __webpack_public_path__ + "img/goldregen-2020-066.ba279db3.jpg";